import { AccountBlock } from '@/modules/projects/components/Workbench/AccountBlock'
import { MemberCards } from '@/modules/projects/components/Workbench/MemberCards'
import {
  type MapSection,
  membersByPrimary,
  orderedRows,
} from '@/modules/projects/components/Workbench/mapBlocks'
import { LANE } from '@/modules/projects/components/Workbench/mapLayout'
import { LaneSection, type LaneSectionProps } from './LaneSection'

type SectionViewProps = Omit<LaneSectionProps, 'lane' | 'children'> & {
  section: MapSection
}

// Accounts mailed together are one block; a lone account is a lane. Their member cards follow
// inside the same section.
export const SectionView = ({ section, ...shared }: SectionViewProps) => {
  const [first, ...rest] = section.lanes
  const memberGroups = membersByPrimary(section.members).map((members) => (
    <MemberCards
      key={members[0]?.memberOf}
      members={members}
      standsAlone={!first}
      highlight={shared.highlight}
      openStatementId={shared.openStatementId}
      onOpenSegment={shared.actions.onOpenSegment}
    />
  ))
  // Null, not an empty list, so an account with no member cards keeps its usual padding.
  const memberRows = memberGroups.length > 0 ? memberGroups : null
  if (!first) return <section className={LANE}>{memberRows}</section>
  if (rest.length > 0) {
    return (
      <AccountBlock lanes={orderedRows(section.lanes)} {...shared}>
        {memberRows}
      </AccountBlock>
    )
  }
  return (
    <LaneSection lane={first} {...shared}>
      {memberRows}
    </LaneSection>
  )
}
